import { render, staticRenderFns } from "./imgSelectItem.vue?vue&type=template&id=73357cb8&"
import script from "./imgSelectItem.vue?vue&type=script&lang=js&"
export * from "./imgSelectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/asq/items/imgSelectItem.vue"
export default component.exports